import { QueryClient } from "@tanstack/react-query";

import { invalidateFavoritesList } from "@/queries/favorites";

export const TOOL_REGISTRY_KEY = "tool-registry";
export const TOOL_REGISTRY_VERSIONS_KEY = "tool-registry-versions";
export const TOOL_REGISTRY_REFERENCES_KEY = "tool-registry-references";

export const invalidateToolRegistryQueries = (queryClient: QueryClient, workspaceId: number) => {
  queryClient.invalidateQueries({ queryKey: [TOOL_REGISTRY_KEY, workspaceId] });
  queryClient.invalidateQueries({ queryKey: ["folder-entities"] });
  invalidateFavoritesList(queryClient, workspaceId);
};

export const invalidateToolVersionQueries = (
  queryClient: QueryClient,
  workspaceId: number,
  toolId: number,
) => {
  queryClient.invalidateQueries({
    queryKey: [TOOL_REGISTRY_VERSIONS_KEY, workspaceId, toolId],
  });
};
